import React, {Fragment} from "react";
import {
    Button,
    Col,
    Collapse,
    Descriptions,
    Divider,
    Dropdown,
    List,
    Menu, notification,
    Popconfirm,
    Row,
    Space,
    Tag,
    Tooltip, Typography
} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    AlertOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined, EditOutlined,
    EnvironmentOutlined, FieldTimeOutlined, FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined, MinusCircleOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined, ReloadOutlined,
    RollbackOutlined, ScheduleOutlined,
    SkinOutlined,
    TagOutlined, VerticalAlignBottomOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait, checkPermissions} from "../../../../components/permissions/functions";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../../../configs/AppConfig";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import moment from "moment";
import ApiService from "../../../../services/ApiService";
import IntlMessage from "../../../../components/util-components/IntlMessage";

const {Text, Title} = Typography

export class FicheFamilles extends React.Component {

    state = {
        familles: []
    }

    componentDidMount() {
        this.getFamilles()
    }


    async getFamilles() {
        var res = await ApiService.get("/contact/familles/")

        if (res.success) {
            this.setState({familles: res.items})
        }

    }


    async onRemoveFamille(familleId) {
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        var res = await ApiService.post("/contact/removefamille/" + this.props.selected.id, {familleId: familleId})
        console.log(res)

        if (res.success) {
            notification.success({
                message: <IntlMessage id="success.delete"/>
            })

            await this.props.fiche.getData()
        } else {
            notification.success({
                message: <IntlMessage id="error.delete"/>
            })
        }
    }

    render() {
        const {selected} = this.props

        if (!selected) {
            return null
        }

        if (selected.familles.length === 0 || this.state.familles.length === 0) {
            return null
        }

        return (
            <Col style={{marginTop: 0}}>
                {selected.familles.map((i, k) => {
                    const famille = this.state.familles.find(f => f.id == i)
                    if (!famille) {
                        return null
                    }

                    return (
                        <Popconfirm
                            key={k}
                            title={'Êtes-vous sûrs de vouloir retirer ce contact de la famille << ' + famille.name + ' >> ?'}
                            onConfirm={() => this.onRemoveFamille(famille.id)}
                            okText="Oui"
                            cancelText="Non"
                            okType={"danger"}
                        >
                            <Tag style={{marginTop: 5, cursor: "pointer"}} key={k}
                                 color={"green"}>{famille.name}</Tag>
                        </Popconfirm>
                    )
                })}
            </Col>
        )
    }
}
